import React from 'react';

import NumberFormat from 'react-number-format';
import { Collapse } from 'react-collapse';
import {
  string,
  bool,
  number,
  func,
  oneOfType,
  arrayOf,
  shape,
  object,
} from 'prop-types';

import AdditionalOneTimeServices from './AdditionalOneTimeServices';
import AdditionalMonthlyServices from './AdditionalMonthlyServices';
import AdditionalMarketplaces from './AdditionalMarketplaces';
import ListingTranslation from './ListingTranslation';
import StandardServicesForNonUS from './StandardServicesForNonUS';
import {
  HYBRID,
  ListingOptimization,
  notIncludeAdvertisingSection,
  SELLER_ACCOUNT_TYPES,
  VENDOR_ACCOUNT_TYPES,
} from '../../../../constants';
import { StatementWork, PlusIcon, MinusIcon } from '../../../../theme/images';
import { Button, InputFormField, ErrorMsg } from '../../../../common';
import StandardServices from './StandardServices';
import { checkDisabledConditionForListing } from '../../../../common/ConditionsForStatementOfWork';
import AdvertisingServices from './AdvertisingServices';

function StatementOfWork({
  executeScroll,
  setOpenCollapse,
  openCollapse,
  statementErrCount,
  renderCollapseBtnErrorHtml,
  loader,
  generateHTML,
  displayError,
  formData,
  contractError,
  handleChange,
  onAddDiscount,
  monthlyService,
  showRightTick,
  nextStep,
  showAdditionalMarketplace,
  setShowAdditionalMarketplace,
  showSection,
  additionalMonthlySerError,
  oneTimeService,
  changeQuantity,
  additionalOnetimeSerError,
  setShowAmazonPlanDropdown,
  amazonService,
  showAmazonPlanDropdown,
  amazonStoreCustom,
  setAmazonStoreCustom,
  AmazonStoreOptions,
  showFooter,
  setContractError,
  setFormData,
  setUpdatedFormData,
  updatedFormData,
  additionalOnetimeServices,
  clearOneTimeQntyError,
  updateAdditionalOnetimeServicesSelectedData,
  setShowCollpase,
  originalData,
  additionalMonthlyServices,
  updateAdditionalMonthlyServices,
  setMonthlyAdditionalServices,
  fetchUncommonOptions,
  getOptions,
  additionalMarketplacesData,
  agreementData,
  setAdditionalMarketplaces,
  updateAdditionalMarketplaces,
  setAdditionalMarketplace,
  setMarketPlaces,
  marketplacesResult,
  discountData,
  servicesFees,
  getData,
  selectedCurrency,
  stdServices,
  setNonUSserviceError,
  nonUsServiceError,
  updateStatementErrorValue,
  sectionError,
  setAdditionalOnetimeServices,
  notIncludedOneTimeServices,
  setNotIncludedOneTimeServices,
  showAmazonStorefrontDropdown,
  setShowAmazonStorefrontDropdown,
  setAdditionalOnetimeSerError,
  addendumDetails,
  contractAddendumDetails,
  details,
  displayMarketplaceName,
  setVatMarketplaces,
  combinedOneTimeServices,
  filterNotIncludedOneTimeServices,
  savedMarketplaces,
  advertisingServices,
  amcServiceError,
  setAmcServiceError,
  getAddedOrRemovedAMCServices,
}) {
  const sellerField = formData?.fee_structure_seller_type;
  const vendorField = formData?.fee_structure_vendor_type;

  const contractType = formData?.contract_type;
  const additionalOneTimeServicesLength =
    formData?.additional_one_time_services?.length;
  const accountType = formData?.seller_type?.value;

  const changeListOptimization = (key, flag) => {
    showFooter(true);
    let updatedData = 0;
    if (
      Object.keys(contractError)?.includes('content_optimization') ||
      Object.keys(contractError)?.includes('design_optimization') ||
      Object.keys(contractError)?.includes('photography_optimization')
    ) {
      setContractError({
        ...contractError,
        [key]: '',
      });
    }
    if (flag === 'minus') {
      if (formData && formData[key]) {
        updatedData =
          parseInt(formData[key], 10) - 1
            ? parseInt(formData[key], 10) - 1
            : null;
      } else {
        updatedData = null;
      }
    }
    if (flag === 'plus') {
      if (formData && formData[key]) {
        if (parseInt(formData[key], 10) < 25) {
          updatedData = parseInt(formData[key], 10) + 1;
        }
      } else {
        updatedData = 1;
      }
    }
    setFormData({
      ...formData,
      [key]: updatedData,
    });
    setUpdatedFormData({
      ...updatedFormData,
      [key]: updatedData,
    });
  };

  const displayListingOptimizations = () => {
    return (
      <>
        <StandardServices
          stdServices={stdServices}
          formData={formData}
          setFormData={setFormData}
          updatedFormData={updatedFormData}
          setUpdatedFormData={setUpdatedFormData}
          showFooter={showFooter}
          contractAddendumDetails={contractAddendumDetails}
          addendumDetails={addendumDetails}
          originalData={originalData}
        />
        {!formData?.isNewChannel && (
          <>
            <InputFormField className="mb-3">
              <label htmlFor="additional_one_time_services ">
                LISTING OPTIMIZATIONS (
                {formData?.isNewChannel ? 'SKU’s' : 'ASIN’s'} PER MONTH)
              </label>
            </InputFormField>
            {ListingOptimization.map((field) => {
              return (
                <React.Fragment key={Math.random()}>
                  <div className="row">
                    <div className="col-7 mb-3">
                      <label
                        htmlFor={field.label}
                        className="listing-optimazation"
                      >
                        {field && field.label}
                      </label>
                    </div>
                    <div className="col-5 pl-0 text-end">
                      <button
                        type="button"
                        className="decrement"
                        onClick={() =>
                          changeListOptimization(field.key, 'minus')
                        }
                        disabled={checkDisabledConditionForListing(
                          formData,
                          field?.key,
                        )}
                      >
                        <img className="minus-icon" src={MinusIcon} alt="" />
                      </button>

                      <NumberFormat
                        name={field.key}
                        className="form-control max-min-number"
                        value={(formData && formData[field.key]) || 0}
                        onChange={(event) =>
                          handleChange(event, 'listing_optimization')
                        }
                        allowNegative={false}
                        isAllowed={(values) => {
                          const { formattedValue, floatValue } = values;
                          if (floatValue == null) {
                            return formattedValue === '';
                          }
                          return floatValue <= 25;
                        }}
                      />

                      <button
                        type="button"
                        className="increment"
                        disabled={
                          formData &&
                          formData[field.key] &&
                          parseInt(formData[field.key], 10) === 25
                        }
                        onClick={() =>
                          changeListOptimization(field.key, 'plus')
                        }
                      >
                        <img className="plus-icon" src={PlusIcon} alt="" />
                      </button>
                    </div>
                    <div className="col-12">
                      {contractError &&
                      contractError[field.key] &&
                      contractError[field.key][0] ? (
                        <ErrorMsg className="mb-3">
                          {contractError &&
                            contractError[field.key] &&
                            contractError[field.key][0]}
                        </ErrorMsg>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </>
        )}
      </>
    );
  };

  const displayAdditionalMonthlyServices = (type) => {
    return (
      <AdditionalMonthlyServices
        onAddDiscount={onAddDiscount}
        formData={formData}
        monthlyService={monthlyService[type]}
        handleChange={handleChange}
        setShowAdditionalMarketplace={setShowAdditionalMarketplace}
        showAdditionalMarketplace={showAdditionalMarketplace}
        generateHTML={generateHTML}
        accountType={type}
        showFooter={showFooter}
        setShowCollpase={setShowCollpase}
        showSection={showSection}
        originalData={originalData}
        additionalMonthlyServices={additionalMonthlyServices}
        setFormData={setFormData}
        updateAdditionalMonthlyServices={updateAdditionalMonthlyServices}
        setMonthlyAdditionalServices={setMonthlyAdditionalServices}
        fetchUncommonOptions={fetchUncommonOptions}
        discountData={discountData}
        updatedFormData={updatedFormData}
        setUpdatedFormData={setUpdatedFormData}
        contractAddendumDetails={contractAddendumDetails}
        addendumDetails={addendumDetails}
      />
    );
  };

  return contractType?.toLowerCase()?.includes('one') ||
    contractType?.toLowerCase()?.includes('dsp') ? null : (
    <>
      <div className="straight-line horizontal-line  " />
      <div
        className="collapse-btn"
        role="presentation"
        type="button"
        onClick={() => {
          if (contractAddendumDetails?.notActive)
            executeScroll('draft-addendum');
          else executeScroll('statement');
          setOpenCollapse({ statement: !openCollapse.statement });
        }}
      >
        <img className="service-agre" src={StatementWork} alt="pdf" />

        <h4
          className={
            statementErrCount
              ? 'sendar-details error-container'
              : 'sendar-details '
          }
        >
          Statement of Work
          {renderCollapseBtnErrorHtml(
            false,
            statementErrCount,
            openCollapse.statement,
            'statement',
          )}
        </h4>
        <div className="clear-fix" />
      </div>
      <Collapse isOpened={openCollapse.statement}>
        {loader ? null : (
          <>
            <ul className="collapse-inner">
              <li>{displayListingOptimizations()}</li>
              {!formData?.isNewChannel && (
                <>
                  {SELLER_ACCOUNT_TYPES.includes(accountType) ||
                  VENDOR_ACCOUNT_TYPES.includes(accountType) ? (
                    <li>
                      {displayAdditionalMonthlyServices(accountType)}{' '}
                      <AdditionalMarketplaces
                        formData={formData}
                        getOptions={getOptions}
                        accountType={accountType}
                        showFooter={showFooter}
                        additionalMarketplacesData={additionalMarketplacesData}
                        setFormData={setFormData}
                        agreementData={agreementData}
                        setAdditionalMarketplaces={setAdditionalMarketplaces}
                        originalData={originalData}
                        updateAdditionalMarketplaces={
                          updateAdditionalMarketplaces
                        }
                        setAdditionalMarketplace={setAdditionalMarketplace}
                        setMarketPlaces={setMarketPlaces}
                        marketplacesResult={marketplacesResult}
                        defaultData={getData(
                          formData?.additional_marketplaces,
                          accountType,
                        )}
                        setShowAdditionalMarketplace={
                          setShowAdditionalMarketplace
                        }
                        showAdditionalMarketplace={showAdditionalMarketplace}
                        contractAddendumDetails={contractAddendumDetails}
                        addendumDetails={addendumDetails}
                        savedMarketplaces={savedMarketplaces}
                        agreementAccountType={accountType?.toLowerCase()}
                      />
                    </li>
                  ) : (
                    ''
                  )}
                  <AdditionalOneTimeServices
                    setAdditionalOnetimeServices={setAdditionalOnetimeServices}
                    formData={formData}
                    setFormData={setFormData}
                    updatedFormData={updatedFormData}
                    setUpdatedFormData={setUpdatedFormData}
                    onAddDiscount={onAddDiscount}
                    additionalMonthlySerError={additionalMonthlySerError}
                    oneTimeService={oneTimeService}
                    handleChange={handleChange}
                    changeQuantity={changeQuantity}
                    additionalOnetimeSerError={additionalOnetimeSerError}
                    setShowAmazonPlanDropdown={setShowAmazonPlanDropdown}
                    amazonService={amazonService}
                    showAmazonPlanDropdown={showAmazonPlanDropdown}
                    AmazonStoreOptions={AmazonStoreOptions}
                    amazonStoreCustom={amazonStoreCustom}
                    displayError={displayError}
                    setAmazonStoreCustom={setAmazonStoreCustom}
                    showFooter={showFooter}
                    additionalOnetimeServices={additionalOnetimeServices}
                    clearOneTimeQntyError={clearOneTimeQntyError}
                    updateAdditionalOnetimeServicesSelectedData={
                      updateAdditionalOnetimeServicesSelectedData
                    }
                    discountData={discountData}
                    servicesFees={servicesFees}
                    selectedCurrency={selectedCurrency}
                    notIncludedOneTimeServices={notIncludedOneTimeServices}
                    setNotIncludedOneTimeServices={
                      setNotIncludedOneTimeServices
                    }
                    showAmazonStorefrontDropdown={showAmazonStorefrontDropdown}
                    setShowAmazonStorefrontDropdown={
                      setShowAmazonStorefrontDropdown
                    }
                    setAdditionalOnetimeSerError={setAdditionalOnetimeSerError}
                    details={details}
                    updateStatementErrorValue={updateStatementErrorValue}
                    sectionError={sectionError}
                    contractAddendumDetails={contractAddendumDetails}
                    combinedOneTimeServices={combinedOneTimeServices}
                    filterNotIncludedOneTimeServices={
                      filterNotIncludedOneTimeServices
                    }
                  />

                  {accountType === HYBRID ? (
                    <>
                      <li className=" liner-titles spacing ">
                        {' '}
                        {sellerField} Services
                      </li>
                      <li>
                        {displayAdditionalMonthlyServices(sellerField)}

                        <AdditionalMarketplaces
                          formData={formData}
                          setAdditionalOnetimeServices={
                            setAdditionalOnetimeServices
                          }
                          getOptions={getOptions}
                          accountType={sellerField}
                          showFooter={showFooter}
                          additionalMarketplacesData={
                            additionalMarketplacesData
                          }
                          setFormData={setFormData}
                          agreementData={agreementData}
                          setAdditionalMarketplaces={setAdditionalMarketplaces}
                          originalData={originalData}
                          updateAdditionalMarketplaces={
                            updateAdditionalMarketplaces
                          }
                          setAdditionalMarketplace={setAdditionalMarketplace}
                          setMarketPlaces={setMarketPlaces}
                          marketplacesResult={marketplacesResult}
                          defaultData={getData(
                            formData?.additional_marketplaces,
                            sellerField,
                          )}
                          setShowAdditionalMarketplace={
                            setShowAdditionalMarketplace
                          }
                          showAdditionalMarketplace={showAdditionalMarketplace}
                          contractAddendumDetails={contractAddendumDetails}
                          addendumDetails={addendumDetails}
                          savedMarketplaces={savedMarketplaces}
                          agreementAccountType={sellerField}
                        />
                      </li>

                      <li className=" liner-titles spacing ">
                        {' '}
                        {vendorField} Services
                      </li>
                      <li>
                        {displayAdditionalMonthlyServices(vendorField)}
                        <AdditionalMarketplaces
                          formData={formData}
                          getOptions={getOptions}
                          accountType={vendorField}
                          showFooter={showFooter}
                          additionalMarketplacesData={
                            additionalMarketplacesData
                          }
                          setFormData={setFormData}
                          agreementData={agreementData}
                          setAdditionalMarketplaces={setAdditionalMarketplaces}
                          originalData={originalData}
                          updateAdditionalMarketplaces={
                            updateAdditionalMarketplaces
                          }
                          setAdditionalMarketplace={setAdditionalMarketplace}
                          setMarketPlaces={setMarketPlaces}
                          marketplacesResult={marketplacesResult}
                          defaultData={getData(
                            formData?.additional_marketplaces,
                            vendorField,
                          )}
                          setShowAdditionalMarketplace={
                            setShowAdditionalMarketplace
                          }
                          showAdditionalMarketplace={showAdditionalMarketplace}
                          contractAddendumDetails={contractAddendumDetails}
                          addendumDetails={addendumDetails}
                          savedMarketplaces={savedMarketplaces}
                          agreementAccountType={vendorField}
                        />
                      </li>
                    </>
                  ) : (
                    ''
                  )}
                  {notIncludeAdvertisingSection.includes(
                    formData?.channel?.value,
                  ) ? null : (
                    <>
                      <li className=" liner-titles spacing ">
                        {' '}
                        Advertising Services
                      </li>
                      <li>
                        <AdvertisingServices
                          advertisingDashboards={advertisingServices}
                          formData={formData}
                          setFormData={setFormData}
                          updatedFormData={updatedFormData}
                          setUpdatedFormData={setUpdatedFormData}
                          selectedCurrency={selectedCurrency}
                          contractAddendumDetails={contractAddendumDetails}
                          details={details}
                          setShowCollpase={setShowCollpase}
                          showSection={showSection}
                          showFooter={showFooter}
                          amcServiceError={amcServiceError}
                          setAmcServiceError={setAmcServiceError}
                          onAddDiscount={onAddDiscount}
                          discountData={discountData}
                          getAddedOrRemovedAMCServices={
                            getAddedOrRemovedAMCServices
                          }
                          originalData={originalData}
                        />
                      </li>

                      <li>
                        <ListingTranslation
                          formData={formData}
                          setFormData={setFormData}
                          setUpdatedFormData={setUpdatedFormData}
                          updatedFormData={updatedFormData}
                          showFooter={showFooter}
                          handleChange={handleChange}
                        />
                      </li>
                      <li>
                        <StandardServicesForNonUS
                          formData={formData}
                          setFormData={setFormData}
                          updatedFormData={updatedFormData}
                          setUpdatedFormData={setUpdatedFormData}
                          originalData={originalData}
                          showFooter={showFooter}
                          setNonUSserviceError={setNonUSserviceError}
                          nonUsServiceError={nonUsServiceError}
                          updateStatementErrorValue={updateStatementErrorValue}
                          sectionError={sectionError}
                          contractAddendumDetails={contractAddendumDetails}
                          addendumDetails={addendumDetails}
                          displayMarketplaceName={displayMarketplaceName}
                          setVatMarketplaces={setVatMarketplaces}
                        />
                      </li>
                    </>
                  )}
                </>
              )}
              <li>
                <Button
                  className={
                    additionalOneTimeServicesLength &&
                    formData.additional_one_time_services.find(
                      (item) => item.name === 'Amazon Store Package',
                    )
                      ? 'btn-primary btn-next-section sidepanel  mt-1 mb-3 w-100 '
                      : 'btn-primary btn-next-section sidepanel mt-1 mb-3 w-100 '
                  }
                  disabled={
                    (formData?.additional_one_time_services?.length &&
                      formData.additional_one_time_services.find(
                        (item) => item.name === 'Amazon Store Package',
                      )) ||
                    !showRightTick('statement')
                  }
                  onClick={() =>
                    showSection && showSection.dspAddendum
                      ? nextStep('dspAddendum')
                      : nextStep('addendum')
                  }
                >
                  Proceed to Next Section
                </Button>
              </li>
            </ul>
          </>
        )}
      </Collapse>
    </>
  );
}

export default StatementOfWork;

StatementOfWork.defaultProps = {
  executeScroll: () => {},
  setOpenCollapse: () => {},
  openCollapse: {},
  statementErrCount: 0,
  renderCollapseBtnErrorHtml: () => {},
  loader: false,
  generateHTML: () => {},
  displayError: () => {},

  formData: {},
  contractError: {},
  handleChange: () => {},
  onAddDiscount: () => {},
  monthlyService: {},
  showRightTick: () => {},
  nextStep: () => {},
  showAdditionalMarketplace: {},
  setShowAdditionalMarketplace: () => {},
  showSection: {},
  additionalMonthlySerError: {},
  oneTimeService: [],
  changeQuantity: () => {},
  additionalOnetimeSerError: {},
  setShowAmazonPlanDropdown: () => {},
  amazonService: {},
  showAmazonPlanDropdown: false,
  amazonStoreCustom: bool,
  setAmazonStoreCustom: func,
  AmazonStoreOptions: [],
  showFooter: () => {},
  setContractError: () => {},
  setFormData: () => {},
  setUpdatedFormData: () => {},
  updatedFormData: {},
  additionalOnetimeServices: {},
  clearOneTimeQntyError: () => {},
  updateAdditionalOnetimeServicesSelectedData: () => {},
  setShowCollpase: () => {},
  originalData: {},
  additionalMonthlyServices: {},
  updateAdditionalMonthlyServices: () => {},
  setMonthlyAdditionalServices: () => {},
  fetchUncommonOptions: () => {},
  getOptions: () => {},
  additionalMarketplacesData: {},
  agreementData: {},
  setAdditionalMarketplaces: () => {},
  updateAdditionalMarketplaces: () => {},
  setAdditionalMarketplace: () => {},
  setMarketPlaces: () => {},
  marketplacesResult: [],
  discountData: [],
  servicesFees: [],
  getData: () => {},
  selectedCurrency: '$ (USD)',
  stdServices: [],
  setNonUSserviceError: () => {},
  nonUsServiceError: {},
  updateStatementErrorValue: () => {},
  sectionError: {},
  setAdditionalOnetimeServices: () => {},
  notIncludedOneTimeServices: [],
  setNotIncludedOneTimeServices: () => {},
  showAmazonStorefrontDropdown: false,
  setShowAmazonStorefrontDropdown: () => {},
  setAdditionalOnetimeSerError: () => {},
  addendumDetails: {},
  contractAddendumDetails: {},
  details: {},
  displayMarketplaceName: () => {},
  setVatMarketplaces: () => {},
  combinedOneTimeServices: [],
  filterNotIncludedOneTimeServices: () => {},
  savedMarketplaces: [],
  advertisingServices: [],
  amcServiceError: {},
  setAmcServiceError: () => {},
  getAddedOrRemovedAMCServices: () => {},
};

StatementOfWork.propTypes = {
  executeScroll: func,
  setOpenCollapse: func,
  openCollapse: shape({
    agreement: bool,
    statement: bool,
    addendum: bool,
    dspAddendum: bool,
  }),
  statementErrCount: number,
  renderCollapseBtnErrorHtml: func,
  loader: bool,
  generateHTML: func,
  displayError: func,

  formData: shape({
    threshold_type: string,
    additional_one_time_services: arrayOf(shape({})),
    additional_monthly_services: arrayOf(shape({})),
    monthly_discount_amount: oneOfType([string, number]),
    monthly_discount_type: oneOfType([string, number]),
  }),
  contractError: shape({
    yoy_percentage: string,
  }),
  handleChange: func,
  onAddDiscount: func,
  monthlyService: shape({}),
  showRightTick: func,
  nextStep: func,
  showAdditionalMarketplace: shape({}),
  setShowAdditionalMarketplace: func,
  showSection: shape({
    addendum: bool,
    dspAddendum: bool,
  }),
  additionalMonthlySerError: oneOfType([string, object]),
  oneTimeService: arrayOf(shape({})),
  changeQuantity: func,
  additionalOnetimeSerError: shape({
    quantity: number,
    custom_amazon_store_price: number,
  }),
  setShowAmazonPlanDropdown: func,
  amazonService: shape({}),
  showAmazonPlanDropdown: bool,
  amazonStoreCustom: bool,
  setAmazonStoreCustom: func,
  AmazonStoreOptions: arrayOf(shape({})),
  showFooter: func,
  setContractError: func,
  setFormData: func,
  setUpdatedFormData: func,
  updatedFormData: shape({}),
  additionalOnetimeServices: shape({
    create: arrayOf(shape({})),
    delete: arrayOf(string, shape({})),
  }),
  clearOneTimeQntyError: func,
  updateAdditionalOnetimeServicesSelectedData: func,
  setShowCollpase: func,
  originalData: shape({}),
  additionalMonthlyServices: shape({}),
  updateAdditionalMonthlyServices: func,
  setMonthlyAdditionalServices: func,
  fetchUncommonOptions: func,
  getOptions: func,
  additionalMarketplacesData: shape({}),
  agreementData: shape({}),
  setAdditionalMarketplaces: func,
  updateAdditionalMarketplaces: func,
  setAdditionalMarketplace: func,
  setMarketPlaces: func,
  marketplacesResult: arrayOf(shape({})),
  discountData: arrayOf(shape({})),
  servicesFees: arrayOf(shape({})),
  getData: func,
  selectedCurrency: string,
  stdServices: arrayOf(shape({})),
  setNonUSserviceError: func,
  nonUsServiceError: shape({}),
  updateStatementErrorValue: func,
  sectionError: shape({}),
  setAdditionalOnetimeServices: func,
  notIncludedOneTimeServices: arrayOf(shape({})),
  setNotIncludedOneTimeServices: func,
  showAmazonStorefrontDropdown: bool,
  setShowAmazonStorefrontDropdown: func,
  setAdditionalOnetimeSerError: func,
  addendumDetails: shape({}),
  contractAddendumDetails: shape({}),
  details: shape({}),
  displayMarketplaceName: func,
  setVatMarketplaces: func,
  combinedOneTimeServices: arrayOf(shape({})),
  filterNotIncludedOneTimeServices: func,
  savedMarketplaces: arrayOf(shape({})),
  advertisingServices: arrayOf(shape({})),
  amcServiceError: shape({}),
  setAmcServiceError: func,
  getAddedOrRemovedAMCServices: func,
};
